import { useScrollToTop } from "@/hooks/useScrollToTop";

/**
 * Component that implements scroll-to-top behavior on route changes
 * Place this inside BrowserRouter
 */
const ScrollToTop = () => {
  useScrollToTop();
  return null;
};

export default ScrollToTop;
